import useSWR from 'swr';
import { useSelector } from 'react-redux';
import { selectFirebaseJWT } from '../redux/features/user/userSlice';
import { apiUrl } from '../api';
import useUserRole from '../utils/useUserRole';

const fetcher = (url, token) =>
  fetch(url, { headers: { Authorization: `Bearer ${token}` } }).then(res => res.json());

export default function use2FAStatus() {
  const token = useSelector(selectFirebaseJWT);
  const isAgent = useUserRole('agent');
  const { data, error } = useSWR(
    token ? [`${apiUrl}/account/2fa-enabled`, token] : null,
    ([url, token]) => fetcher(url, token)
  );
  
  return {
    is2FAEnabled: data?.twoFAEnabled,
    pinEnabled: data?.pinEnabled,
    loading: !error && !data,
    error,
    // For agents, check if PIN is enabled instead of 2FA
    isSecurityRequired: isAgent ? !data?.pinEnabled : !data?.twoFAEnabled,
  };
}